import React, { useState, useEffect, useMemo } from 'react';
import { X } from 'lucide-react';
import axios from 'axios';
import { useApp } from '../context/AppContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const CookieBanner = () => {
  const { language } = useApp();
  const [isVisible, setIsVisible] = useState(false);
  const [bannerText, setBannerText] = useState('');

  useEffect(() => {
    const cookieConsent = localStorage.getItem('cookie_consent');
    if (cookieConsent) return;

    let mounted = true;

    const fetchSettings = async () => {
      try {
        const { data } = await axios.get(`${BACKEND_URL}/api/settings/global`);
        if (mounted && data.enable_cookie_banner) {
          setBannerText(
            data.cookie_banner_text?.[language] ||
              'We use cookies to improve your experience. By continuing to use this site, you accept our use of cookies.'
          );
          setIsVisible(true);
        }
      } catch (error) {
        console.error('Failed to fetch cookie banner settings');
      }
    };

    fetchSettings();

    return () => {
      mounted = false;
    };
  }, [language]);

  const handleAccept = useMemo(() => {
    return () => {
      localStorage.setItem('cookie_consent', 'accepted');
      setIsVisible(false);
    };
  }, []);

  const handleDecline = useMemo(() => {
    return () => {
      localStorage.setItem('cookie_consent', 'declined');
      setIsVisible(false);
    };
  }, []);

  if (!isVisible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-0 left-0 right-0 z-50 glass p-6 border-t border-white/10"
    >
      <div className="container mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="text-sm text-foreground flex-1">{bannerText}</p>
        <div className="flex items-center gap-4">
          <button
            data-testid="cookie-accept-button"
            onClick={handleAccept}
            className="bg-primary text-primary-foreground px-6 py-2 text-sm uppercase tracking-wider hover:bg-primary/90 transition-colors"
          >
            {language === 'ro' ? 'Accept' : language === 'en' ? 'Accept' : 'Accepter'}
          </button>
          <button
            data-testid="cookie-decline-button"
            onClick={handleDecline}
            className="border border-white/20 text-foreground px-6 py-2 text-sm uppercase tracking-wider hover:bg-white/5 transition-colors"
          >
            {language === 'ro' ? 'Refuz' : language === 'en' ? 'Decline' : 'Refuser'}
          </button>
          <button
            data-testid="cookie-close-button"
            onClick={handleDecline}
            className="text-foreground hover:text-primary transition-colors"
          >
            <X size={20} />
          </button>
        </div>
      </div>
    </div>
  );
};